import { useContent, useLang } from "../../i18n";
import "./style.scss";

export const Header = () => {
  const { nav } = useContent();
  const { lang, setLang } = useLang();

  return (
    <div className="header">
      <div className="container">
        <div className="right-header">
          <img src="/assets/logo/logo.png" alt="MedHub" />
        </div>
        <div className="left-header">
          <a href="#providers">{nav.providers}</a>
          <a href="#features">{nav.members}</a>
          <a href="#plans">{nav.plans}</a>
          <a href="#organizations">{nav.organizations}</a>
          <a href="#capabilities">{nav.capabilities}</a>
          <a href="#about">{nav.about}</a>
          <a href="#contact">{nav.contact}</a>
          <button
            type="button"
            className="lang-toggle"
            lang={lang === "ar" ? "en" : "ar"}
            onClick={() => setLang(lang === "ar" ? "en" : "ar")}
          >
            {nav.switchTo}
          </button>
        </div>
      </div>
    </div>
  );
};
